import React, { useState } from 'react';

const InputGroup = ({ label, section, name, prefix = "₹", type = "number", formData, handleSectionChange }) => (
    <div className="form-group" style={{ marginBottom: '12px' }}>
        <label style={{ fontSize: '0.9rem', marginBottom: '4px', display: 'block' }}>{label}</label>
        <div className="input-with-icon" style={{ position: 'relative' }}>
            {prefix && <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>{prefix}</span>}
            <input
                type={type}
                value={formData[section][name]}
                onChange={(e) => handleSectionChange(section, name, e.target.value)}
                placeholder="Enter details"
                style={{ paddingLeft: prefix ? '25px' : '10px', width: '100%', padding: `8px 10px 8px ${prefix ? '25px' : '10px'}`, borderRadius: '6px', border: '1px solid #d1d5db' }}
                onWheel={(e) => type === 'number' && e.target.blur()}
            />
        </div>
    </div>
);

const ComparisonInput = ({ label, section, hField, wField, formData, handleSectionChange }) => (
    <div className="joint-row" style={{ marginBottom: '15px' }}>
        <label style={{ fontSize: '0.9rem', marginBottom: '8px', display: 'block', fontWeight: '600' }}>{label}</label>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
            <div>
                <span style={{ fontSize: '0.75rem', color: '#6b7280', display: 'block', marginBottom: '4px' }}>Husband</span>
                <div className="input-with-icon" style={{ position: 'relative' }}>
                    <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>₹</span>
                    <input
                        type="number"
                        value={formData[section][hField]}
                        onChange={(e) => handleSectionChange(section, hField, e.target.value)}
                        placeholder="0"
                        style={{ paddingLeft: '25px', width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                    />
                </div>
            </div>
            <div>
                <span style={{ fontSize: '0.75rem', color: '#6b7280', display: 'block', marginBottom: '4px' }}>Wife</span>
                <div className="input-with-icon" style={{ position: 'relative' }}>
                    <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>₹</span>
                    <input
                        type="number"
                        value={formData[section][wField]}
                        onChange={(e) => handleSectionChange(section, wField, e.target.value)}
                        placeholder="0"
                        style={{ paddingLeft: '25px', width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                    />
                </div>
            </div>
        </div>
    </div>
);

const OtherIncomeInput = ({ label, section, formData, setFormData }) => {
    const handleAdd = (person) => {
        setFormData(prev => ({
            ...prev,
            [section]: {
                ...prev[section],
                [`${person}OtherIncomes`]: [...(prev[section][`${person}OtherIncomes`] || []), { type: '', amount: '' }]
            }
        }));
    };

    const handleRemove = (person, index) => {
        setFormData(prev => {
            const newIncomes = [...(prev[section][`${person}OtherIncomes`] || [])];
            newIncomes.splice(index, 1);
            return updateTotals(prev, section, person, newIncomes);
        });
    };

    const handleChange = (person, index, field, value) => {
        setFormData(prev => {
            const newIncomes = [...(prev[section][`${person}OtherIncomes`] || [])];
            newIncomes[index] = { ...newIncomes[index], [field]: value };
            return updateTotals(prev, section, person, newIncomes);
        });
    };

    const updateTotals = (prev, section, person, newIncomes) => {
        const totalAmount = newIncomes.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
        const types = newIncomes.map(i => i.type).filter(Boolean).join(', ');
        return {
            ...prev,
            [section]: {
                ...prev[section],
                [`${person}OtherIncomes`]: newIncomes,
                [`${person}OtherIncome`]: totalAmount > 0 ? totalAmount.toString() : '',
                [`${person}OtherIncomeType`]: types
            }
        };
    };

    const renderList = (person) => {
        const incomes = formData[section][`${person}OtherIncomes`] || [{ type: '', amount: '' }];
        return (
            <div>
                <span style={{ fontSize: '0.75rem', color: '#6b7280', display: 'block', marginBottom: '4px' }}>{person === 'husband' ? 'Husband' : 'Wife'}</span>
                {incomes.map((item, index) => (
                    <div key={index} style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
                        <select
                            value={item.type}
                            onChange={(e) => handleChange(person, index, 'type', e.target.value)}
                            style={{ width: '45%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '0.85rem' }}
                        >
                            <option value="">Select Source</option>
                            <option value="Rent">Rent</option>
                            <option value="Freelance">Freelance</option>
                            <option value="Interest">Interest</option>
                            <option value="House Property">House Property</option>
                            <option value="Business / Profession">Business / Profession</option>
                            <option value="Capital Gains">Capital Gains</option>
                            <option value="Agricultural Income">Agricultural Income</option>
                            <option value="Other Sources">Other Sources</option>
                        </select>
                        <div className="input-with-icon" style={{ position: 'relative', flex: 1 }}>
                            <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>₹</span>
                            <input
                                type="number"
                                value={item.amount}
                                onChange={(e) => handleChange(person, index, 'amount', e.target.value)}
                                placeholder="Amount"
                                style={{ paddingLeft: '25px', width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                            />
                        </div>
                        {incomes.length > 1 && (
                            <button type="button" onClick={() => handleRemove(person, index)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', fontSize: '1.2rem', padding: '0 4px' }} title="Remove">&times;</button>
                        )}
                    </div>
                ))}
                <button type="button" onClick={() => handleAdd(person)} style={{ background: 'none', border: 'none', color: '#3b82f6', fontSize: '0.8rem', cursor: 'pointer', padding: 0, marginTop: '4px' }}>+ Add More Income</button>
            </div>
        );
    };

    return (
        <div className="joint-row" style={{ marginBottom: '15px' }}>
            <label style={{ fontSize: '0.9rem', marginBottom: '8px', display: 'block', fontWeight: '600' }}>{label}</label>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', alignItems: 'start' }}>
                {renderList('husband')}
                {renderList('wife')}
            </div>
        </div>
    );
};

const SchoolFeesInputGroup = ({ label, section, amountName, freqName, formData, handleSectionChange }) => {
    const amountValue = formData[section][amountName] || '';
    const frequency = formData[section][freqName] || 'monthly';

    // Calculate monthly equivalent for display
    let divisor = 1;
    if (frequency === 'annually') divisor = 12;
    else if (frequency === 'halfYearly') divisor = 6;
    else if (frequency === 'quarterly') divisor = 3;

    const monthlyValue = parseFloat(amountValue) > 0 && frequency !== 'monthly' 
        ? (parseFloat(amountValue) / divisor).toFixed(2) 
        : null;

    const onAmountChange = (val) => {
        handleSectionChange(section, amountName, val);
        // Recalculate monthly schoolFees
        const amt = parseFloat(val) || 0;
        let monthly = amt;
        if (frequency === 'annually') monthly = amt / 12;
        else if (frequency === 'halfYearly') monthly = amt / 6;
        else if (frequency === 'quarterly') monthly = amt / 3;
        
        handleSectionChange(section, 'schoolFees', monthly > 0 ? monthly.toFixed(2) : '');
    };

    const onFreqChange = (freq) => {
        handleSectionChange(section, freqName, freq);
        // Recalculate monthly schoolFees
        const amt = parseFloat(amountValue) || 0;
        let monthly = amt;
        if (freq === 'annually') monthly = amt / 12;
        else if (freq === 'halfYearly') monthly = amt / 6;
        else if (freq === 'quarterly') monthly = amt / 3;
        
        handleSectionChange(section, 'schoolFees', monthly > 0 ? monthly.toFixed(2) : '');
    };

    return (
        <div className="form-group" style={{ marginBottom: '12px', gridColumn: 'span 2' }}>
            <label style={{ fontSize: '0.9rem', marginBottom: '4px', display: 'block' }}>{label}</label>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', alignItems: 'start' }}>
                <div>
                    <div className="input-with-icon" style={{ position: 'relative' }}>
                        <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280' }}>₹</span>
                        <input
                            type="number"
                            value={amountValue}
                            onChange={(e) => onAmountChange(e.target.value)}
                            placeholder="Enter amount"
                            style={{ paddingLeft: '25px', width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }}
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', gap: '15px', height: '36px', alignItems: 'center', flexWrap: 'wrap' }}>
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.85rem', color: '#4b5563' }}>
                        <input
                            type="radio"
                            name={freqName}
                            value="monthly"
                            checked={frequency === 'monthly'}
                            onChange={(e) => onFreqChange(e.target.value)}
                            style={{ margin: 0, marginRight: '6px', width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span>Monthly</span>
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.85rem', color: '#4b5563' }}>
                        <input
                            type="radio"
                            name={freqName}
                            value="quarterly"
                            checked={frequency === 'quarterly'}
                            onChange={(e) => onFreqChange(e.target.value)}
                            style={{ margin: 0, marginRight: '6px', width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span>Quarterly</span>
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.85rem', color: '#4b5563' }}>
                        <input
                            type="radio"
                            name={freqName}
                            value="halfYearly"
                            checked={frequency === 'halfYearly'}
                            onChange={(e) => onFreqChange(e.target.value)}
                            style={{ margin: 0, marginRight: '6px', width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span>6 Months</span>
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.85rem', color: '#4b5563' }}>
                        <input
                            type="radio"
                            name={freqName}
                            value="annually"
                            checked={frequency === 'annually'}
                            onChange={(e) => onFreqChange(e.target.value)}
                            style={{ margin: 0, marginRight: '6px', width: '16px', height: '16px', flexShrink: 0 }}
                        />
                        <span>1 Year</span>
                    </label>
                </div>
            </div>
            {monthlyValue && (
                <div style={{ fontSize: '0.75rem', color: '#059669', background: '#f0fdf4', padding: '4px 8px', borderRadius: '4px', marginTop: '6px', display: 'inline-block' }}>
                    <strong>Monthly Equivalent: ₹{parseFloat(monthlyValue).toLocaleString('en-IN', { maximumFractionDigits: 2 })}</strong>
                </div>
            )}
        </div>
    );
};

const JointFinancialForm = ({ data, updateData, nextStep, prevStep, isProcessing }) => {
    const [formData, setFormData] = useState({
        sectionA: {
            husbandName: data?.sectionA?.husbandName || '', wifeName: data?.sectionA?.wifeName || '',
            husbandAge: data?.sectionA?.husbandAge || '', wifeAge: data?.sectionA?.wifeAge || '',
            cityType: data?.sectionA?.cityType || '', familyStatus: data?.sectionA?.familyStatus || ''
        },
        sectionB: {
            husbandSalary: data?.sectionB?.husbandSalary || '', 
            husbandOtherIncome: data?.sectionB?.husbandOtherIncome || '',
            husbandOtherIncomeType: data?.sectionB?.husbandOtherIncomeType || '',
            husbandOtherIncomes: data?.sectionB?.husbandOtherIncomes || (data?.sectionB?.husbandOtherIncome ? [{ type: data?.sectionB?.husbandOtherIncomeType || '', amount: data?.sectionB?.husbandOtherIncome }] : [{ type: '', amount: '' }]),
            wifeSalary: data?.sectionB?.wifeSalary || '', 
            wifeOtherIncome: data?.sectionB?.wifeOtherIncome || '',
            wifeOtherIncomeType: data?.sectionB?.wifeOtherIncomeType || '',
            wifeOtherIncomes: data?.sectionB?.wifeOtherIncomes || (data?.sectionB?.wifeOtherIncome ? [{ type: data?.sectionB?.wifeOtherIncomeType || '', amount: data?.sectionB?.wifeOtherIncome }] : [{ type: '', amount: '' }])
        },
        sectionC: {
            homeLoanEMI: data?.sectionC?.homeLoanEMI || '', personalLoanEMI: data?.sectionC?.personalLoanEMI || '',
            carLoanEMI: data?.sectionC?.carLoanEMI || '', groceries: data?.sectionC?.groceries || '',
            transport: data?.sectionC?.transport || '', dining: data?.sectionC?.dining || '',
            shopping: data?.sectionC?.shopping || '', healthInsurance: data?.sectionC?.healthInsurance || '',
            rent: data?.sectionC?.rent || '', schoolFees: data?.sectionC?.schoolFees || '',
            schoolFeesAmount: data?.sectionC?.schoolFeesAmount || '',
            schoolFeesFrequency: data?.sectionC?.schoolFeesFrequency || 'monthly',
            otherExpenses: data?.sectionC?.otherExpenses || ''
        },
        sectionD: {
            husbandEPF: data?.sectionD?.husbandEPF || '', wifeEPF: data?.sectionD?.wifeEPF || '',
            husbandPPF: data?.sectionD?.husbandPPF || '', wifePPF: data?.sectionD?.wifePPF || '',
            husbandMutualFund: data?.sectionD?.husbandMutualFund || '', wifeMutualFund: data?.sectionD?.wifeMutualFund || '',
            husbandELSS: data?.sectionD?.husbandELSS || '', wifeELSS: data?.sectionD?.wifeELSS || '',
            husbandNPS: data?.sectionD?.husbandNPS || '', wifeNPS: data?.sectionD?.wifeNPS || '',
            husbandFD: data?.sectionD?.husbandFD || '', wifeFD: data?.sectionD?.wifeFD || '',
            husbandOtherInvest: data?.sectionD?.husbandOtherInvest || '', wifeOtherInvest: data?.sectionD?.wifeOtherInvest || ''
        },
        sectionE: {
            husbandLifeCover: data?.sectionE?.husbandLifeCover || '', wifeLifeCover: data?.sectionE?.wifeLifeCover || '',
            husbandLifePremium: data?.sectionE?.husbandLifePremium || '', wifeLifePremium: data?.sectionE?.wifeLifePremium || '',
            husbandHealthCover: data?.sectionE?.husbandHealthCover || '', wifeHealthCover: data?.sectionE?.wifeHealthCover || '',
            husbandHealthPremium: data?.sectionE?.husbandHealthPremium || '', wifeHealthPremium: data?.sectionE?.wifeHealthPremium || ''
        },
        sectionF: {
            homeLoanOutstanding: data?.sectionF?.homeLoanOutstanding || '', homeLoanEMI: data?.sectionF?.homeLoanEMI || '', homeLoanRate: data?.sectionF?.homeLoanRate || '',
            personalLoanOutstanding: data?.sectionF?.personalLoanOutstanding || '', personalLoanEMI: data?.sectionF?.personalLoanEMI || '', personalLoanRate: data?.sectionF?.personalLoanRate || '',
            carLoanOutstanding: data?.sectionF?.carLoanOutstanding || '', carLoanEMI: data?.sectionF?.carLoanEMI || '', carLoanRate: data?.sectionF?.carLoanRate || '',
            creditCardOutstanding: data?.sectionF?.creditCardOutstanding || '', creditCardRate: data?.sectionF?.creditCardRate || ''
        },
        sectionG: { emergencyFund: data?.sectionG?.emergencyFund || '' },
        sectionH: {
            taxRegime: data?.sectionH?.taxRegime || '', claimHRA: data?.sectionH?.claimHRA || '',
            claimHomeLoanInterest: data?.sectionH?.claimHomeLoanInterest || '', healthInsuranceOutside: data?.sectionH?.healthInsuranceOutside || '',
            npsContributions: data?.sectionH?.npsContributions || '', rentAgreement: data?.sectionH?.rentAgreement || ''
        },
        sectionI: {
            retirementCorpus: data?.sectionI?.retirementCorpus || '', retirementHorizon: data?.sectionI?.retirementHorizon || '',
            childEducation: data?.sectionI?.childEducation || '', childEducationHorizon: data?.sectionI?.childEducationHorizon || '',
            vacation: data?.sectionI?.vacation || '', vacationHorizon: data?.sectionI?.vacationHorizon || '',
            otherGoal: data?.sectionI?.otherGoal || '', otherGoalHorizon: data?.sectionI?.otherGoalHorizon || ''
        },
        sectionJ: { homeValue: data?.sectionJ?.homeValue || '', carValue: data?.sectionJ?.carValue || '', otherAssets: data?.sectionJ?.otherAssets || '' }
    });

    const [currentSubStep, setCurrentSubStep] = useState(1);
    const [expandedSections, setExpandedSections] = useState({
        sectionA: true, sectionB: true, sectionC: true, sectionD: true,
        sectionE: true, sectionF: true, sectionG: true, sectionH: true,
        sectionI: true, sectionJ: true
    });

    const toggleSection = (section) => {
        setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
    };

    const handleSectionChange = (section, field, value) => {
        setFormData(prev => ({ ...prev, [section]: { ...prev[section], [field]: value } }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (currentSubStep < 4) {
            setCurrentSubStep(currentSubStep + 1);
            window.scrollTo(0, 0);
        } else {
            updateData(formData);
            nextStep(formData);
        }
    };

    const handleBack = () => {
        if (currentSubStep > 1) {
            setCurrentSubStep(currentSubStep - 1);
            window.scrollTo(0, 0);
        } else {
            prevStep();
        }
    };


    return (
        <div className="form-step">
            <h2 className="step-title">Joint Financial Diagnosis (Part {currentSubStep})</h2>
            <p className="step-description">Please enter details for both individuals to generate a household report.</p>

            <form onSubmit={handleSubmit} className="diagnosis-form">
                {currentSubStep === 1 && (
                    <>
                        <div className="expense-section">
                            <h4 className="subsection-title collapsible" onClick={() => toggleSection('sectionA')}>
                                <span>1. Basic Family Profile</span>
                                <span className="toggle-icon">{expandedSections.sectionA ? '▼' : '▶'}</span>
                            </h4>
                            {expandedSections.sectionA && (
                                <div style={{ padding: '10px' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
                                        <div className="form-group">
                                            <label style={{ fontSize: '0.9rem' }}>Husband's Name *</label>
                                            <input type="text" value={formData.sectionA.husbandName} onChange={(e) => handleSectionChange('sectionA', 'husbandName', e.target.value)} placeholder="Name" required className="form-control" style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db' }} />
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontSize: '0.9rem' }}>Wife's Name *</label>
                                            <input type="text" value={formData.sectionA.wifeName} onChange={(e) => handleSectionChange('sectionA', 'wifeName', e.target.value)} placeholder="Name" required className="form-control" style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db' }} />
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontSize: '0.9rem' }}>Husband's Age *</label>
                                            <input type="number" value={formData.sectionA.husbandAge} onChange={(e) => handleSectionChange('sectionA', 'husbandAge', e.target.value)} placeholder="Age" required className="form-control" style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db' }} />
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontSize: '0.9rem' }}>Wife's Age *</label>
                                            <input type="number" value={formData.sectionA.wifeAge} onChange={(e) => handleSectionChange('sectionA', 'wifeAge', e.target.value)} placeholder="Age" required className="form-control" style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db' }} />
                                        </div>
                                    </div>
                                    <InputGroup label="City & Type (e.g. Pune Metro)" section="sectionA" name="cityType" prefix="" type="text" formData={formData} handleSectionChange={handleSectionChange} />
                                    <InputGroup label="Family Status (e.g. DINK, Kids)" section="sectionA" name="familyStatus" prefix="" type="text" formData={formData} handleSectionChange={handleSectionChange} />
                                </div>
                            )}
                        </div>

                        <div className="expense-section">
                            <h4 className="subsection-title collapsible" onClick={() => toggleSection('sectionB')}>
                                <span>2. Individual Monthly Income</span>
                                <span className="toggle-icon">{expandedSections.sectionB ? '▼' : '▶'}</span>
                            </h4>
                            {expandedSections.sectionB && (
                                <div style={{ padding: '10px' }}>
                                    <ComparisonInput label="Monthly Take-Home Salary (Monthly)" section="sectionB" hField="husbandSalary" wField="wifeSalary" formData={formData} handleSectionChange={handleSectionChange} />
                                    <OtherIncomeInput 
                                        label="Other Income (Rent/Freelance)" 
                                        section="sectionB" 
                                        formData={formData} 
                                        setFormData={setFormData} 
                                    />
                                </div>
                            )}
                        </div>
                    </>
                )}

                {currentSubStep === 2 && (
                    <>
                        <div className="expense-section">
                            <h4 className="subsection-title collapsible" onClick={() => toggleSection('sectionC')}>
                                <span>3. Joint Household Expenses</span>
                                <span className="toggle-icon">{expandedSections.sectionC ? '▼' : '▶'}</span>
                            </h4>
                            {expandedSections.sectionC && (
                                <div style={{ padding: '10px' }}>
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                        <InputGroup label="Home Rent / EMI (Monthly)" section="sectionC" name="rent" formData={formData} handleSectionChange={handleSectionChange} />
                                        <InputGroup label="Groceries & Food (Monthly)" section="sectionC" name="groceries" formData={formData} handleSectionChange={handleSectionChange} />
                                        <InputGroup label="Transport / Fuel (Monthly)" section="sectionC" name="transport" formData={formData} handleSectionChange={handleSectionChange} />
                                        <InputGroup label="Dining & Fun (Monthly)" section="sectionC" name="dining" formData={formData} handleSectionChange={handleSectionChange} />
                                        <InputGroup label="Health Insurance (Monthly)" section="sectionC" name="healthInsurance" formData={formData} handleSectionChange={handleSectionChange} />
                                        <SchoolFeesInputGroup 
                                            label="Children School Fees" 
                                            section="sectionC" 
                                            amountName="schoolFeesAmount" 
                                            freqName="schoolFeesFrequency" 
                                            formData={formData} 
                                            handleSectionChange={handleSectionChange} 
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="expense-section">
                            <h4 className="subsection-title collapsible" onClick={() => toggleSection('sectionD')}>
                                <span>4. Existing Monthly Savings</span>
                                <span className="toggle-icon">{expandedSections.sectionD ? '▼' : '▶'}</span>
                            </h4>
                            {expandedSections.sectionD && (
                                <div style={{ padding: '10px' }}>
                                    <ComparisonInput label="EPF Contribution" section="sectionD" hField="husbandEPF" wField="wifeEPF" formData={formData} handleSectionChange={handleSectionChange} />
                                    <ComparisonInput label="PPF Contribution" section="sectionD" hField="husbandPPF" wField="wifePPF" formData={formData} handleSectionChange={handleSectionChange} />
                                    <ComparisonInput label="Mutual Fund SIP" section="sectionD" hField="husbandMutualFund" wField="wifeMutualFund" formData={formData} handleSectionChange={handleSectionChange} />
                                </div>
                            )}
                        </div>
                    </>
                )}

                {currentSubStep === 3 && (
                    <>
                        <div className="expense-section">
                            <h4 className="subsection-title collapsible" onClick={() => toggleSection('sectionE')}>
                                <span>5. Risk Protection (Cover)</span>
                                <span className="toggle-icon">{expandedSections.sectionE ? '▼' : '▶'}</span>
                            </h4>
                            {expandedSections.sectionE && (
                                <div style={{ padding: '10px' }}>
                                    <ComparisonInput label="Life Insurance Cover" section="sectionE" hField="husbandLifeCover" wField="wifeLifeCover" formData={formData} handleSectionChange={handleSectionChange} />
                                    <ComparisonInput label="Health Insurance Cover" section="sectionE" hField="husbandHealthCover" wField="wifeHealthCover" formData={formData} handleSectionChange={handleSectionChange} />
                                </div>
                            )}
                        </div>

                        <div className="expense-section">
                            <h4 className="subsection-title collapsible" onClick={() => toggleSection('sectionF')}>
                                <span>6. Outstanding Debts</span>
                                <span className="toggle-icon">{expandedSections.sectionF ? '▼' : '▶'}</span>
                            </h4>
                            {expandedSections.sectionF && (
                                <div style={{ padding: '10px' }}>
                                    {['homeLoan', 'personalLoan', 'carLoan'].map(loan => (
                                        <div key={loan} style={{ marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px dashed #e2e8f0' }}>
                                            <label style={{ fontSize: '0.85rem', fontWeight: '700', marginBottom: '8px', display: 'block' }}>{loan.replace('Loan', ' Loan').toUpperCase()}</label>
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                                <div className="input-with-icon" style={{ position: 'relative' }}>
                                                    <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280', fontSize: '0.8rem' }}>₹</span>
                                                    <input type="number" placeholder="Outstanding" value={formData.sectionF[`${loan}Outstanding`]} onChange={(e) => handleSectionChange('sectionF', `${loan}Outstanding`, e.target.value)} style={{ width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }} />
                                                </div>
                                                <div className="input-with-icon" style={{ position: 'relative' }}>
                                                    <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#6b7280', fontSize: '0.8rem' }}>₹</span>
                                                    <input type="number" placeholder="Monthly EMI" value={formData.sectionF[`${loan}EMI`]} onChange={(e) => handleSectionChange('sectionF', `${loan}EMI`, e.target.value)} style={{ width: '100%', padding: '8px 10px 8px 25px', borderRadius: '6px', border: '1px solid #d1d5db' }} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </>
                )}

                {currentSubStep === 4 && (
                    <>
                        <div className="expense-section">
                            <h4 className="subsection-title collapsible" onClick={() => toggleSection('sectionH')}>
                                <span>7. Tax Filing & Assets</span>
                                <span className="toggle-icon">{expandedSections.sectionH ? '▼' : '▶'}</span>
                            </h4>
                            {expandedSections.sectionH && (
                                <div style={{ padding: '10px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                    <div className="form-group">
                                        <label style={{ fontSize: '0.85rem' }}>Tax Regime</label>
                                        <select value={formData.sectionH.taxRegime} onChange={(e) => handleSectionChange('sectionH', 'taxRegime', e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db' }}>
                                            <option value="">Select</option>
                                            <option value="old">Old</option>
                                            <option value="new">New</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label style={{ fontSize: '0.85rem' }}>Claim HRA?</label>
                                        <select value={formData.sectionH.claimHRA} onChange={(e) => handleSectionChange('sectionH', 'claimHRA', e.target.value)} style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db' }}>
                                            <option value="">Select</option>
                                            <option value="husband">Husband</option>
                                            <option value="wife">Wife</option>
                                            <option value="both">Both</option>
                                            <option value="no">No</option>
                                        </select>
                                    </div>
                                    <InputGroup label="Home Market Value" section="sectionJ" name="homeValue" formData={formData} handleSectionChange={handleSectionChange} />
                                    <InputGroup label="Car Value" section="sectionJ" name="carValue" formData={formData} handleSectionChange={handleSectionChange} />
                                </div>
                            )}
                        </div>

                        <div className="expense-section">
                            <h4 className="subsection-title collapsible" onClick={() => toggleSection('sectionI')}>
                                <span>8. Financial Goals</span>
                                <span className="toggle-icon">{expandedSections.sectionI ? '▼' : '▶'}</span>
                            </h4>
                            {expandedSections.sectionI && (
                                <div style={{ padding: '10px' }}>
                                    {['Retirement', 'Child Education', 'Vacation'].map(goal => {
                                        const field = goal.toLowerCase().replace(' ', '');
                                        return (
                                            <div key={goal} style={{ marginBottom: '12px', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', alignItems: 'center' }}>
                                                <div style={{ fontSize: '0.85rem', fontWeight: '600' }}>{goal}</div>
                                                <input type="number" placeholder="Target ₹" value={formData.sectionI[field === 'retirement' ? 'retirementCorpus' : field]} onChange={(e) => handleSectionChange('sectionI', field === 'retirement' ? 'retirementCorpus' : field, e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db' }} />
                                                <input type="number" placeholder="Horizon (Yrs)" value={formData.sectionI[`${field}Horizon`]} onChange={(e) => handleSectionChange('sectionI', `${field}Horizon`, e.target.value)} style={{ padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db' }} />
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </>
                )}

                <div className="form-actions">
                    <button type="button" onClick={handleBack} className="btn-secondary">← Back</button>
                    <button type="submit" className="btn-primary" disabled={isProcessing}>
                        {isProcessing ? 'Processing...' : (currentSubStep < 4 ? 'Next Step →' : 'Review Summary →')}
                    </button>
                </div>
            </form>

            <style jsx>{`
                .expense-section { margin-bottom: 25px; padding: 15px; background: #f9fafb; border-radius: 8px; }
                .subsection-title { color: #4b5563; margin-bottom: 12px; font-size: 0.95rem; font-weight: 600; }
                .subsection-title.collapsible { cursor: pointer; user-select: none; display: flex; justify-content: space-between; align-items: center; padding: 10px; background: #fff; border-radius: 6px; transition: background-color 0.2s; border: 1px solid #e2e8f0; }
                .subsection-title.collapsible:hover { background: #f3f4f6; }
                .toggle-icon { font-size: 0.8rem; color: #6b7280; }
                .joint-row { border-bottom: 1px solid #f1f5f9; padding-bottom: 15px; }
                .joint-row:last-child { border-bottom: none; }
            `}</style>
        </div>
    );
};

export default JointFinancialForm;
